<template>
    <div class="and-or-template row" :class="{'and-or-first': isFirst}">
        <div class="col">
            <div class="form-group and-or-top row">
                <div class="col-5" style="padding: 0">
                    <div class="btn-group btn-group-sm" role="group" aria-label="And/Or">
                        <oc-button text="And" @click.prevent="clickAnd" size="small" class="btn-rule-outline btn-radius" :class="{'btn-rule-outline-focus': isAnd}" />
                        <oc-button text="Or" @click.prevent="clickOr" size="small" class="btn-rule-outline btn-radius" :class="{'btn-rule-outline-focus': !isAnd}" />
                    </div>
                </div>

                <div class="col-7 btn-and-or">
                    <oc-button v-if="!lock" icon="close" @click.prevent="deleteSelf()" size="small" class="btn-rule pull-right" />
                    <oc-button @click.prevent="addGroup" text="+ ( group )" size="small" class="btn-rule pull-right" />
                    <oc-button @click.prevent="addRule" text="+ ( rule )" size="small" class="btn-rule add-rule pull-right" />
                </div>
            </div>

            <oc-query-builder-rule
                v-for="(rule, index) in group.rules"
                v-if="!rule.logic_op"
                :key="index"
                :parentPath="getParentPath(index)"
                @delete-rule="deleteItem(index)"
                ref="rules"
            >
                <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="data">
                    <slot :name="slot" v-bind="data"></slot>
                </template>
            </oc-query-builder-rule>

            <oc-query-builder-group
                v-for="(rule, index) in group.rules"
                v-if="rule.logic_op"
                :key="index"
                :group="rule"
                :parentPath="getParentPath(index)"
                @delete-group="deleteItem(index)"
                ref="groups"
                class="and-or-offset col-11"
            >
                <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="data">
                    <slot :name="slot" v-bind="data"></slot>
                </template>
            </oc-query-builder-group>
        </div>
    </div>
</template>

<script>
import Rule from '@/components/ui/filter/QueryBuilder/Rule.vue'
import SchemaMixin from '@/components/ui/filter/QueryBuilder/helpers/SchemaMixin'

export default {
    name: 'oc-query-builder-group',
    mixins: [SchemaMixin],
    components: {
        [Rule.name]: Rule
    },
    inject: ['params', '$component'],
    props: {
        isFirst: {
            type: Boolean,
            default: false
        },
        lock: {
            type: Boolean,
            default: false
        },
        parentPath: {
            type: String,
            default: ''
        },
        group: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: this.params.form
        }
    },
    computed: {
        isAnd() {
            return this.group.logic_op.toUpperCase() === 'AND'
        },
        pathPrefix() {
            let prefix = ''
            if( this.params.modelSchemaKey !== null ) {
                prefix = this.params.modelSchemaKey
            }
            return prefix
        }
    },
    methods: {
        getParentPath(index) {
            if( this.isFirst ) {
                let path = `rules.${index}`

                if( this.params.modelSchemaKey !== null ) {
                    return this.params.modelSchemaKey + '.' + path
                }

                return path
            }
            return `${this.parentPath}.rules.${index}`
        },
        addRule() {
            this.group.rules.push({
                key: '',
                op: '',
                value: ''
            })

            this.$component.$emit('add-rule', {
                path: this.getParentPath(this.group.rules.length - 1)
            })
        },
        addGroup() {
            this.group.rules.push(
                this.getSchema()
            )

            this.$component.$emit('add-group', {
                path: this.getParentPath(this.group.rules.length - 1)
            })
        },
        clickAnd() {
            this.group.logic_op = 'AND'

            this.$component.$emit('change-logic-op', {
                value: this.group.logic_op,
                path: this.isFirst ? this.pathPrefix : this.parentPath
            })
        },
        clickOr() {
            this.group.logic_op = 'OR'

            this.$component.$emit('change-logic-op', {
                value: this.group.logic_op,
                path: this.isFirst ? this.pathPrefix : this.parentPath
            })
        },
        deleteSelf() {
            this.$emit('delete-group', {
                path: this.isFirst ? this.pathPrefix : this.parentPath
            })
        },
        deleteItem(index) {
            this.group.rules.splice(index, 1)

            this.$component.$emit('delete-rule', {
                path: this.getParentPath(index)
            })

            // check if this was the last rule then add at one rule
            if( this.group.rules.length === 0 ) {
                this.addRule()
            }
            //
        }
    }
}
</script>
